import { LocationSearch } from '../containers/SportsBookContainer';
import { SPORT_NAV_CATEGORY_LABEL } from '../data-types/sports/sportsEnums';
import { SEARCH_PARAM_KEY } from '../data-types/url/urlEnums';
import { PATHS } from '../routing-system/appPaths';
import browserHistory from '../routing-system/browserHistory';
import { getSearchParamValue } from './search';

export const getLocationSearchData = (locationSearch: string | undefined): LocationSearch | undefined => {
  if (!!locationSearch) {
    const sport = getSearchParamValue(SEARCH_PARAM_KEY.SPORT, locationSearch);
    const section = getSearchParamValue(SEARCH_PARAM_KEY.SECTION, locationSearch);
    const subsection = getSearchParamValue(SEARCH_PARAM_KEY.SUB_SECTION, locationSearch);

    let searchObj: LocationSearch | undefined;

    if (typeof sport === 'string') {
      searchObj = {
        sport,
        section: undefined,
        subSection: undefined,
      };

      if (typeof section === 'string') {
        searchObj = {
          ...searchObj,
          section,
        };

        if (typeof subsection === 'string') {
          searchObj = {
            ...searchObj,
            subSection: subsection,
          };
        }
      }
    }

    return searchObj;
  }

  return undefined;
};

export const getSportIdAndSectionName = (sportIdString: string, section: string) => {
  const sportIdNumber = Number(sportIdString);
  const sportId = isNaN(sportIdNumber) ? sportIdString : sportIdNumber;
  const sectionName = section === SPORT_NAV_CATEGORY_LABEL.HRS_24.toLowerCase() ? SPORT_NAV_CATEGORY_LABEL.HRS_24 : section;
  return { sportId, sectionName };
};

export const removeQueryStringParametersFromLogin = () => {
  const path = window.location.pathname;
  const searchParams = window.location.search;

  if (path.startsWith(PATHS.LOGIN.ROOT) && searchParams) {
    browserHistory.replace(PATHS.LOGIN.ROOT);
  }
};
